import React, { FC, Fragment, ReactNode } from 'react';
import { Divider, Grid, Hidden } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Desktop, Mobile } from '../';
import { columnSplitToGridSizes } from 'helpers';
import palette from 'theme/palette';
import { GroupColorMap } from 'api';

const styles = (theme: Theme) =>
  createStyles({
    mobileBody: {
      padding: '24px 16px',
    },
    divider: {
      height: 3,
      [theme.breakpoints.down('md')]: {
        marginTop: 12,
      },
    },
    headerWrapper: {
      padding: `0 ${theme.spacing(2)}px`,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  left: ReactNode;
  right: ReactNode;
  hideRightOnMobile?: boolean;
  header?: ReactNode;
  dividerColor?: keyof typeof palette | GroupColorMap['hex'];
  desktopSplit?: string;
}

const AppMain2Column: FC<IProps> = props => {
  const { classes, desktopSplit, dividerColor, header, hideRightOnMobile, left, right } = props;
  const [desktopLeft, desktopRight] = columnSplitToGridSizes(desktopSplit);

  function renderHeader() {
    return (
      <Grid item xs>
        {header}
      </Grid>
    );
  }

  function renderDivider() {
    const backgroundColor = palette[dividerColor] || dividerColor;

    return <Divider style={{ backgroundColor }} className={classes.divider} />;
  }

  function renderDesktop() {
    const spacing = header ? 3 : 0;

    return (
      <Grid container direction="column" spacing={spacing}>
        {header && renderHeader()}
        {dividerColor && renderDivider()}
        <Grid item xs>
          <Grid container spacing={4}>
            <Grid item xs={desktopLeft}>
              {left}
            </Grid>
            <Grid item xs={desktopRight}>
              {right}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function renderMobile() {
    const wrapperClass = !!header && !!dividerColor ? classes.headerWrapper : '';

    return (
      <Fragment>
        <div className={wrapperClass}>
          {header && renderHeader()}
          {dividerColor && renderDivider()}
        </div>
        <div className={classes.mobileBody}>
          <Grid container direction="column" spacing={3}>
            <Grid item xs>
              {left}
            </Grid>
            <Hidden mdDown={hideRightOnMobile}>
              <Grid item xs>
                {right}
              </Grid>
            </Hidden>
          </Grid>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Desktop>{renderDesktop()}</Desktop>
      <Mobile>{renderMobile()}</Mobile>
    </Fragment>
  );
};

AppMain2Column.defaultProps = {
  desktopSplit: '9/3',
  hideRightOnMobile: false,
};

export default withStyles(styles)(AppMain2Column);
